/* unplugin-vue-components disabled */import { render } from "./add-tracker.vue?vue&type=template&id=040efc16&scoped=true"
import script from "./add-tracker.vue?vue&type=script&lang=js"
export * from "./add-tracker.vue?vue&type=script&lang=js"

import "./add-tracker.vue?vue&type=style&index=0&id=040efc16&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-040efc16"],['__file',"src/components/widgets/tracker/add-tracker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "040efc16"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('040efc16', __exports__)) {
    api.reload('040efc16', __exports__)
  }
  
  module.hot.accept("./add-tracker.vue?vue&type=template&id=040efc16&scoped=true", () => {
    api.rerender('040efc16', render)
  })

}


export default __exports__